export default [
  {
    path: '/admin/purchase-requests',
    name: 'purchase-request',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-request/index.vue')
  },
  {
    path: '/admin/purchase-requests/create',
    name: 'purchase-request-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-request/create.vue')
  },
  {
    path: '/admin/purchase-requests/:id/edit',
    name: 'purchase-request-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-request/edit.vue')
  }
]